import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import { createI18n } from 'vue-i18n'
import hr from './locales/hr.json'
import en from './locales/en.json'
import sl from './locales/slo.json'
import de from './locales/de.json'
import it from './locales/ita.json'

const i18n = createI18n({
  legacy: false,
  locale: 'hr',
  fallbackLocale: 'en',
  messages: { hr, en, sl, de, it },
})

const userLang = localStorage.getItem('user-locale') || navigator.language.split('-')[0] || 'hr'
i18n.global.locale.value = userLang

const app = createApp(App)
const head = createHead()

app.use(router)
app.use(i18n)
app.use(head)

app.mount('#app')


